import React, { FunctionComponent, ReactNode } from 'react'
import styles from './OkCancel.module.sass'
import Button, { ButtonStyle } from '../Button/Button'
import clsx from 'clsx'
import { TooltipTitle } from '../../etc/Tooltip'
import CloseIcon from 'files/close.svg'
import { Colors } from '../../../styles'

interface Props {
    className?: string,
    color?: string,
    text?: string,
    icon?: ReactNode,
    onOk?: () => void,
    onCancel?: () => void,
    disabled?: boolean,
    title?: TooltipTitle,
}

const OkCancel: FunctionComponent<Props> = props => {
    return <div className={clsx(props.className, styles.actions)}>
        <Button
            title={'Отмена'}
            buttonStyle={ButtonStyle.TINTED}
            color={Colors.red}
            onClick={props.onCancel}
        >
            <CloseIcon/>
        </Button>
        <Button
            disabled={props.disabled}
            title={props.title}
            buttonStyle={ButtonStyle.BORDERED}
            color={props.color ?? Colors.blue}
            onClick={props.onOk}
        >
            {props.icon}
            {props.text || (props.color === Colors.red ? 'Удалить' : 'Сохранить')}
        </Button>
    </div>
}

export default OkCancel